const SET_LOADING = state => {
    state.loading = true
    state.error = {}
}

const RESET_LOADING = state => {
    state.loading = false
}

const SET_PROFILE_SUCCESS = (state, payload) => {
    state.data = payload
}

const SET_PROFILE_FAILURE = (state, error) => {
    state.error = error
}

const SET_MESSAGE = (state, message) => {
    state.message = message
}

const RESET_MESSAGE = state => {
    state.message = null
}

export default {
    SET_MESSAGE,
    SET_LOADING,
    RESET_LOADING,
    RESET_MESSAGE,
    SET_PROFILE_SUCCESS,
    SET_PROFILE_FAILURE
}



// WEBPACK FOOTER //
// ./src/state/modules/profile/mutations.js